import request from '@/plugin/axios'

/**
 * 获取部门所属模块
 * @returns {Promise<any>}
 */
export function getDepartmentModule() {
  return new Promise(resolve => {
    resolve({
      admin: '后台',
      home: '前台',
      api: 'API'
    })
  })
}

/**
 * 根据权限获取部门列表
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getDepartmentAuthList(data) {
  return request({
    url: '/oa/department/auth',
    method: 'get',
    data
  })
}

/**
 * 获取部门列表
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getDepartmentList(data) {
  return request({
    url: '/oa/department/list',
    method: 'get',
    params: data
  })
}

export function getDepartmentAllList() {
  return request({
    url: '/oa/department/allList',
    method: 'get'
  })
}

/**
 * 获取一个部门
 * @param {Number} menuId
 * @returns {AxiosPromise}
 */
export function getMenuItem(menuId) {
  return request({
    url: '/v1/menu',
    method: 'post',
    params: {
      method: 'get.menu.item'
    },
    data: {
      menuId
    }
  })
}

/**
 * 添加一个部门
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function addDepartmentItem(data) {
  return request({
    url: '/finance/adjustAccounts/saveDepartment',
    method: 'post',
    data
  })
}

/**
 * 编辑一个部门
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function editDepartmentItem(data) {
  return request({
    url: '/finance/adjustAccounts/updateDepartment',
    method: 'put',
    data
  })
}

/**
 * 根据编号自动设置排序值
 * @param {Array} departmentId
 * @returns {AxiosPromise}
 */
export function editDepartmentIndex(departmentId) {
  return request({
    url: '/oa/department/orderNum',
    method: 'put',
    data: {
      departmentId
    }
  })
}

/**
 * 设置部门状态，同时会影响上级与下级部门的状态
 * @param {Number} departmentId
 * @param {Number} status
 * @returns {AxiosPromise}
 */
export function editDepartmentStatus(departmentId, status) {
  return request({
    url: '/oa/department/status',
    method: 'post',
    data: {
      departmentId,
      status
    }
  })
}
/**
 * 删除部门
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function delDepartmentItem(data) {
  return request({
    url: '/finOa/department/disabled',
    method: 'post',
    data: data
  })
}

/**
 * 同步erp部门
 * @returns 
 */
 export function synchronizeErpDept() {
  return request({
    url: '/erp.api/erpOa/synchronizeErpDept',
    method: 'post'
  })
}
